import { Injectable } from '@angular/core';
import { FolderViewModel } from '@ca/core/models';

@Injectable()
export class FileExplorerHistoryService {
    private _history: FolderViewModel[] = [];

    /**
     * Retrieves the history.
     * We cannot make a getter out of this, because unit tests would fail with:
     * "Cannot find a differ supporting object" (because we cannot iterate over a getter in *ngFor).
     * If the error is gone, change to getter.
     */
    getHistory(): FolderViewModel[] {
        return this._history;
    }
    set history(val: FolderViewModel[]) {
        this._history = val;
    }
    lastFolderOfHistory(): FolderViewModel | undefined {
        let folder: FolderViewModel | undefined;
        if (this._history.length > 0) {
            folder = this._history[this._history.length - 1];
        }
        return folder;
    }

    navigateTo(folder: FolderViewModel): void {
        // avoid references - make immutable
        folder = { ...folder };

        const indexOfCurrentFolder = this._history.findIndex((f: FolderViewModel) => f.id === folder.id);
        if (indexOfCurrentFolder > -1) {
            // Remove all elements which come after the current element
            this._history.splice(indexOfCurrentFolder + 1);
        } else {
            if (!this._history?.length) {
                // unset 'name' for root folder, to be able to default to 'translatedRootTitle' in breadcrumb
                folder.name = undefined;
            }
            this._history.push(folder);
        }
    }

    /**
     * @deprecated - Use navigateTo method instead since this method checks if folder is already in history and navigates to it.
     */
    addToHistory(folder: FolderViewModel): void {
        // avoid references - make immutable
        folder = { ...folder };

        this._history.push(folder);
    }

    /**
     * @deprecated - Use navigateTo method instead since this method checks if folder is already in history and navigates to it.
     */
    goBackInHistoryTo(folder: FolderViewModel) {
        if (this._history.length > 0) {
            const indexOfCurrentFolder = this._history.findIndex((folderIterator: FolderViewModel) => folderIterator.id === folder.id);
            const indexToCutBreadcrumbFrom = indexOfCurrentFolder + 1;
            if (indexOfCurrentFolder > -1 && this._history[indexToCutBreadcrumbFrom] != null) {
                // Remove all elements which come after the current element
                this._history.splice(indexToCutBreadcrumbFrom);
            }
        }
    }

    clearHistory(): void {
        this._history = [];
    }
}
